import moment from "moment";

export default {
  data() {
    return {
      timeText: null,
      infoText: null,
      signupNoticeId: '',
      signupStatus: null
    };
  },
  created() {
    console.log('[-> Index]', 'areaId', this.areaId, 'studentType', this.studentType);
    if (this.studentType === 1) {
      this.infoText = '告知：填报时幼儿监护人应根据幼儿所在户籍填报所属学校，学生身份证号最多只能填报一所幼儿园，同时要确保相关证件的真实有效，如有隐瞒或弄虚作假，一经查实，一切后果家长自行负责。';
    } else {
      this.infoText = '告知：申请人应对所提供的材料真实性负责，在入学安排过程中，发现提供虚假信息、证件、证明和其他材料弄虚作假者，一经查实将依法追究责任并取消入学资格。';
    }
    this.getNewNoticeProtocol();
  },
  watch: {},
  methods: {
    async onClickSignup() {
      if (!this.hasRead) return this.$message.warn('请勾选已阅读并接受隐私保护协议！');
      await this.getNewNoticeProtocol();
      // 0=未开始、1=进行中、2=已结束
      let { signupNoticeId, signupStatus } = this;
      // debug todo delete
      if (signupStatus === 1 || this.$route.query.test === '1') {
        this.$router.push({
          path: './bm_notes',
          query: { signupNoticeId }
        });
      } else if (signupStatus === 0) {
        this.$message.warn('抱歉，还未开始报名！');
      } else if (signupStatus === 2) {
        this.$message.warn('抱歉，报名已结束！');
      } else {
        this.$message.error('系统错误，请稍后再试！');
      }
    },
    async getNewNoticeProtocol() {
      // 获取最新1条报名通知/须知 #李茹钰/2019-03-12#
      this.$message.loading();
      let { error, data } = await this.$ajax.gateway('/bm/ISignupNoticeApi_newNoticeProtocol', {
				METHOD: 'get',
        areaId: this.areaId,
        studentType: this.studentType
      });
      this.$message.hide();
      if (!error && data.code === 200) {
        data = data.data;
        // 0=未开始、1=进行中、2=已结束
        this.signupStatus = data.signupStatus;
        if (data.signupBegin) {
          let txt = '';
          // let begin = data.signupBegin.split('-');
          // let end = data.signupEnd.split('-');
          const begin = moment(data.signupBegin).format('YYYY')+'年' + moment(data.signupBegin).format('MM')+'月' + 
                        moment(data.signupBegin).format('DD')+'日' + moment(data.signupBegin).format('HH:mm')
          const end = moment(data.signupEnd).format('YYYY')+'年' + moment(data.signupEnd).format('MM')+'月' +
                      moment(data.signupEnd).format('DD')+'日' + moment(data.signupEnd).format('HH:mm')
          // txt = begin[0] + '年' + begin[1] + '月' + begin[2] + '日至' + end[0] + '年' + end[1] + '月' + end[2] + '日'
          this.timeText = begin +'至' + end;
          this.signupNoticeId = data.signupNoticeId;
        }
      } else if (error) {
        this.$message.error('系统异常，请稍后再试！');
      }
    }
  }
};
